import { Accordion, Grid, Icon, Segment } from 'semantic-ui-react';
import styled from 'styled-components';

export const StyledGrid = styled(Grid)`
margin-left: 0 !important;
margin-bottom: 0 !important;
`
export const StyledSegment = styled(Segment)`
border: none !important;
background: none !important;
box-shadow: none !important;
padding: 0px 22px !important;
 .ui header {
  font-size: 1.1rem !important;
 }
`

export const StyledTaxGridRow = styled(Grid.Row)`
padding-bottom: 5px !important;
align-items: center !important;
flex-wrap: no-wrap !important;
`

export const FarmerProfileLogo = styled.div`
  display: flex;
  flex: 1 1 0%;
  margin-left: 12px;
  margin-top: 12px;
  align-items: center;
  justify-content: flex-start;
  .farmer-title {
    font-size: 18px !important;
    font-weight: bold !important;
    margin-right: 10px;
  }
  i.big.icon.{
    font-size: 3em !important;
  }
  .farmer-logo-container {
    position: relative;
    flex: none;
    height: 6rem;
    width: 6rem;
  > span {
    position: absolute;
    height: 100%;
    width: 100%;
    -o-object-fit: contain;
    object-fit: contain;
    border-radius: 9999px;
    background: #f5f5f5;
    > img {
      position: absolute;
      height: 100%;
      width: 100%;
      -o-object-fit: scale-down;
      object-fit: scale-down;
      border-radius: 9999px;
      background: #f5f5f5;
    }
    }    
  }
  .farmer-name-container {
    margin-left: 10px;
    .label {
    font-weight: 700 !important;
  }
  }

  .farmer-abbrevation {
    background: rgb(51, 153, 255);
    color: white;
    margin-left: 10px !important;
    border-radius: 15px;
  }

  .farmer-supplier {
    font-size: 14px !important;
    margin-bottom: 5px;
  }

  .farmer-company-name {
    font-size: 20px !important;
    font-weight: bold !important;
  }
`;

export const StyledDefaultProfile = styled(Icon)`
font-size: 6em !important;
position: absolute;
top: 50%;
left: 50%;
color: #c3c3c3;
transform: translate(-50%, -50%);
`
export const FarmerDetailsWrapper = styled.div`
  background-color: rgb(241 245 249);
  padding: 1.25rem 1rem;
  margin: 1rem 0rem;
  border-radius: 1.3rem;
  .farmer-label-wrapper {
    display: flex;
    align-items: baseline;
  }
  .farmer-label {
    font-size: 16px !important;
  }
  .farmer-info {
    font-weight: bold;
    margin-left: 10px;
    font-size: 16px !important;
  }
  .farmer-logo {
    display: flex;
    align-items: center;
  }
  .farmer-label-logo {
    font-size: 16px !important;
    margin-right: 10px;
  }
`;

export const StyledAccordion = styled(Accordion)`
width: calc(25% + 300px) !important;
margin-top: 15px;
 .title {
   display: flex;
   align-items: baseline;
   justify-content: space-between;
   color: black !important;
 }
`
export const FilterWrapper = styled.div`
display: flex;
align-items: baseline;
flex-wrap: wrap;
gap: 10px;
 .ui.selection.active.dropdown .menu {
  max-height: 130px !important;
 }

`
export const VatStyledWrapper = styled.div`
display: flex;
margin-bottom: 3px;
justify-content: end;
 .left-side-wrapper {
  display: flex;
  gap: 5px;
  align-items: center;
 } 
`